module.exports = {
      id: "app-gallery-usage",
      viewBox: "0 0 161 48",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#app-gallery",
      toString: function () {
        return this.url;
      }
    }